// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../../components/MKBox";
import MKTypography from "../../../../components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "../../../../examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "../../../../assets/images/team/sree.png";
import team2 from "../../../../assets/images/team/Madhuri.jpg";
import team3 from "../../../../assets/images/team/dore.JPG";
import team4 from "../../../../assets/images/team/shashi.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              The Executive Team
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
            Meet the brilliant minds behind Cynefian's success - driving innovation and leading us towards a transformative future.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Sreenidhi"
                position={{ color: "info", label: "Co-Founder & CEO" }}
                description="'Our purpose is to help people and organizations dream bigger, move faster, and build better tomorrows for all.'"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Madhuri Gopal"
                position={{ color: "info", label: "Co-Founder & COO" }}
                description="'We value each person’s uniqueness and encourage our team members to be their authentic selves.'"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Doreswamy"
                position={{ color: "info", label: "Director" }}
                description="'We’re committed to operating every part of business in ways that are sustainable and responsible, while creating innovative solutions.'"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Shashikala"
                position={{ color: "info", label: "Director" }}
                description="'Our core values are an active part of everything we do. Each one reminds us to stay true to ourselves while driving amazing outcomes.'"
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
